<template>
    <section class="w-full bg-blue-100">
        <div class="bg-white rounded-b-2xl">
            <div class="self-gutter">
                <div class="self-gutter-y self-content-sm">
                    <h1 class="title-2xl">{{ $t('bonuspoints.points_since_last_year') }}</h1>
                    <div class="pt-24 self-hero-intro expandable-description" :class="{ 'show-full-desc': showFullDesc }">
                        <p>
                            {{ $t('bonuspoints.collected') }} <span class="text-blue-400">{{ bpTransactions.final_amount }}</span>
                            {{ $t('bonuspoints.points') }}.
                        </p>
                        <p v-html="$t('bonuspoints.desc')"></p>
                        <a ref="showFullDesc" class="text-blue-400 cursor-pointer expand-link bg-white" style="font-style: italic">{{
                            $t('reports.read_more')
                        }}</a>
                    </div>
                </div>
            </div>
        </div>

        <!--   TABLE     -->
        <article v-if="bpTransactions">
            <section id="resultsTable" class="relative bg-blue-100 rounded-b-2xl self-gutter-y">
                <div class="self-gutter">
                    <div class="self-content-sm">
                        <div class="self-table-info">
                            <div class="flex items-center sm-down:w-full sm-down:justify-between">
                                <!--                            <span class="block text-base">{{ $t('Lõppsaldo') }}: <span-->
                                <!--                                class="font-semibold whitespace-nowrap">{{ bpTransactions.final_amount }}</span></span>-->

                                <!--                                <div class="self-table-info-entries-count"></div>-->
                            </div>

                            <div class="flex items-center sm-down:w-full sm-down:justify-between sm-down:pt-16">
                                <div class="self-table-info-entries-select"></div>

                                <div class="relative inline-block">
                                    <div class="relative inline-block">
                                        <button
                                            ref="exportButton"
                                            class="self-btn-plain"
                                            id="export-report"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            @click="dropdown('exportButton')"
                                        >
                                            <span class="self-btn-plain__text">{{ $t('reports.table.export') }}</span>
                                            <span class="self-btn-plain__icon self-moreinfo-icon">
                                                <IconArrowForwardSVG />
                                            </span>
                                        </button>

                                        <div class="e5-dropdown e5-dropdown-xs" aria-labelledby="export-report">
                                            <div class="p-10">
                                                <a class="py-5 self-text-link hover:cursor-pointer" href="#" @click="download('.xlsx')"
                                                    >Excel (XLSX)</a
                                                >
                                                <a class="py-5 self-text-link hover:cursor-pointer" href="#" @click="download('.csv')"
                                                    >CSV</a
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <table class="w-full self-table" v-if="bpTransactions">
                            <thead>
                                <tr>
                                    <th>
                                        <span>{{ $t('bonuspoints.table_desc') }}</span>
                                    </th>
                                    <th class="date">
                                        <span>{{ $t('bonuspoints.table_date') }}</span>
                                    </th>
                                    <th>
                                        <span>{{ $t('bonuspoints.table_points') }}</span>
                                    </th>
                                    <th class="date">
                                        <span>{{ $t('bonuspoints.table_expiration_date') }}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="font-semibold">
                                    <td>{{ $t('bonuspoints.initial_balance') }}</td>
                                    <td>
                                        {{
                                            new Date(new Date().getFullYear() - 1, 0, 1).toLocaleDateString('et-EE', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })
                                        }}
                                    </td>
                                    <td>{{ bpTransactions.initial_amount }}</td>
                                    <td></td>
                                </tr>
                                <tr
                                    v-for="item in bpTransactions.transactions"
                                    :key="
                                        item.bkg_ref_no +
                                        '-' +
                                        item.transaction_date +
                                        '-' +
                                        item.expiration_date +
                                        '-' +
                                        item.invoice_no +
                                        '-' +
                                        item.amount +
                                        '-' +
                                        item.explanation +
                                        '-' +
                                        item.type
                                    "
                                >
                                    <td>{{ item.explanation }}</td>
                                    <td>{{ formatDate(item.transaction_date) }}</td>
                                    <td>{{ item.amount }}</td>
                                    <td>{{ formatDate(item.expiration_date) }}</td>
                                </tr>
                                <!--                            <tr class="font-semibold">-->
                                <!--                                <td>Punktide muutus</td>-->
                                <!--                                <td>{{-->
                                <!--                                        new Date().toLocaleDateString('et-EE', {-->
                                <!--                                            day: '2-digit',-->
                                <!--                                            month: '2-digit',-->
                                <!--                                            year: 'numeric'-->
                                <!--                                        })-->
                                <!--                                    }}-->
                                <!--                                </td>-->
                                <!--                                <td>{{ bpTransactions.initial_amount - bpTransactions.final_amount }}</td>-->
                                <!--                                <td></td>-->
                                <!--                            </tr>-->
                                <tr class="font-semibold">
                                    <td>{{ $t('bonuspoints.final_balance') }}</td>
                                    <td>
                                        {{
                                            new Date().toLocaleDateString('et-EE', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })
                                        }}
                                    </td>
                                    <td>{{ bpTransactions.final_amount }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </article>
    </section>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { IBpTransactionsResponce } from '@/domain/IBpTransactions';
import IconArrowForwardSVG from '@/assets/static/icons-src/icon-arrow-forward.svg';
import UtilsMixin from '@/scripts/utils';
import $ from 'jquery';
import * as XLSX from 'xlsx';

@Component({
    components: {
        IconArrowForwardSVG
    },
    metaInfo: {
        title: 'Bonuspoints'
    },
    mixins: [UtilsMixin]
})
export default class BonuspointsView extends Vue {
    private extraTable = null;
    showFullDesc = false;

    get bpTransactions(): IBpTransactionsResponce {
        return this.$store.getters.getBpTransactions;
    }

    private createExtraTable() {
        this.destroyExtraTable();
        $.fn.dataTable.ext.errMode = 'throw';

        this.extraTable = $('.self-table').DataTable({
            dom: '<ilf<t>p>',
            paging: false,
            info: false,
            searching: false,
            scrollX: true,
            order: [],
            ordering: false,
            language: {
                lengthMenu: this.$t('datatable.lengthMenu') as string,
                info: this.$t('datatable.info') as string,
                zeroRecords: this.$t('datatable.zeroRecords') as string,
                paginate: {
                    first: this.$t('datatable.first') as string,
                    last: this.$t('datatable.last') as string,
                    next: this.$t('datatable.next') as string,
                    previous: this.$t('datatable.previous') as string
                }
            },
            retrieve: true
        });
    }

    // Method to retrieve table data as an object
    private getTableData() {
        const data = this.extraTable.rows().data().toArray();
        const columns = this.extraTable
            .columns()
            .header()
            .toArray()
            .map((col) => col.innerText);

        return data.map((row) => {
            const obj = {};
            row.forEach((cell, index) => {
                obj[columns[index]] = cell;
            });
            return obj;
        });
    }

    private destroyExtraTable() {
        if (this.extraTable != null) {
            this.extraTable.destroy();
            this.extraTable = null;
        }
    }

    private download(DownloadFileType) {
        const invoices = this.getTableData();
        // Sanitize the data
        const sanitizedInvoices = invoices.map((invoice) => {
            const sanitizedInvoice = {};
            for (const key in invoice) {
                if (Object.prototype.hasOwnProperty.call(invoice, key)) {
                    sanitizedInvoice[key] = invoice[key].replace(/<\/?[^>]+(>|$)/g, ''); // remove html tags
                }
            }
            return sanitizedInvoice;
        });

        const data = XLSX.utils.json_to_sheet(sanitizedInvoices);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, data, 'data');
        if (DownloadFileType === '.xlsx') {
            XLSX.writeFile(wb, 'bonuspoints-transactions.xlsx');
        } else if (DownloadFileType === '.csv') {
            XLSX.writeFile(wb, 'bonuspoints-transactions.csv', { bookType: 'csv' });
        }
    }

    // Type Declarations for TypeScript to tell that these methods exist in utils.ts
    initDescriptionExpansion!: () => void;

    @Watch('$i18n.locale', { immediate: true })
    async onLocaleChange() {
        this.createExtraTable();
        this.initDescriptionExpansion();
    }

    mounted(): void {
        this.createExtraTable();
        this.initDescriptionExpansion();
    }
}
</script>

<style scoped></style>
